import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetBillPaymentsMadeQuery } from "../../../services/Reports";
import {
  getBillPaymentsMadeRequest,
  getBillPaymentsMadeFailure,
  getBillPaymentsMadeSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allBillPaymentsMade,
    isLoading: billPaymentsMadeLoading,
    isError: billPaymentsMadeError,
  } = useGetBillPaymentsMadeQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.billPaymentsMadePageNo,
    pageSize: state.billPaymentsMadePageSize,
    fromDate: new Date(state.billPaymentsMadeFromDate).toLocaleDateString(),
    toDate: new Date(state.billPaymentsMadeToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (billPaymentsMadeLoading) {
      dispatch(getBillPaymentsMadeRequest());
    }
    if (billPaymentsMadeError) {
      dispatch(getBillPaymentsMadeFailure(billPaymentsMadeError));
    }
    if (allBillPaymentsMade) {
      dispatch(
        getBillPaymentsMadeSuccess({
          data: allBillPaymentsMade.data.billPaymentsMade[0].data || [],
          totalPages:
            allBillPaymentsMade.data.billPaymentsMade[0].metadata[0]?.total ||
            0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allBillPaymentsMade,
    profileData,
    state.billPaymentsMadeFromDate,
    state.billPaymentsMadeToDate,
    state.billPaymentsMadePageNo,
    state.billPaymentsMadePageSize,
  ]);
  return <></>;
};
export default Content;
